<form (ngSubmit)="onSubmit()" [formGroup]="loginForm">

	<div class="form-floating mb-3">
		<input type="text" class="form-control" id="username" placeholder=" " formControlName="username" />
		<label for="username">Username</label>
	</div>

	<div class="form-floating mb-4 position-relative">
		<input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" placeholder=" " formControlName="password" />
		<label for="password">Password</label>
	</div>

	<div class="d-grid">
		<button type="submit" class="btn btn-primary rounded-3">
			Login
		</button>
	</div>
	<button class="btn btn-link" (click)="doForgotPassword()">Forgot Password</button>
</form>
